<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    @click.self="emit('close')"
  >
    <div class="w-full max-w-md p-6 bg-white shadow-xl rounded-2xl">
      <div class="flex items-start">
        <div
          class="flex items-center justify-center w-12 h-12 mr-4 text-white bg-red-500 rounded-full"
        >
          <i class="fa-solid fa-lock"></i>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-bold text-gray-900">Sesi Berakhir</h3>
          <p class="mt-1 text-sm text-gray-600">
            Sesi Anda telah berakhir. Silakan login kembali untuk melanjutkan.
          </p>
        </div>
      </div>

      <div class="flex justify-end mt-6 space-x-3">
        <button
          type="button"
          class="px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          @click="emit('close')"
        >
          Tutup
        </button>
        <button
          type="button"
          class="px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
          @click="goLogin"
        >
          Login
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { router } from "@inertiajs/vue3";

const props = defineProps({
  show: { type: Boolean, default: false },
});
const emit = defineEmits(["close"]);

function goLogin() {
  // Arahkan ke halaman login
  router.visit("/login");
}
</script>

<style scoped></style>
